import { Component, input } from '@angular/core';
import { FileResponse } from '../../../../core/clients/omni-core/models';
import { DocumentLmaEmbed } from '../document-lma-embed/document-lma-embed';
import { DocumentText } from '../document-text/document-text';
import { DocumentCsvTable } from '../document-csv-table/document-csv-table';
import { DocumentIcon } from '../document-icon/document-icon';
import { Button } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { DocumentFileSignedUrlPipe } from '../../pipes/document-file-signed-url-pipe';
import { DocumentResourceUrlPipe } from '../../pipes/document-resource-url-pipe';
import { TranslocoPipe } from '@jsverse/transloco';
import { DocumentDownloadButton } from '../document-download-button/document-download-button';

@Component({
  selector: 'app-document-preview',
  imports: [
    DocumentLmaEmbed,
    DocumentText,
    DocumentCsvTable,
    DocumentIcon,
    Button,
    NgIcon,
    DocumentFileSignedUrlPipe,
    DocumentResourceUrlPipe,
    TranslocoPipe,
    DocumentDownloadButton,
  ],
  templateUrl: './document-preview.html',
})
export class DocumentPreview {
  document = input.required<FileResponse>();
  organizationID = input.required<string>();
}
